import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { CustomRedeemWindow } from "../../product/models/custom-redeem-window";

export class EventSummary {
  public readonly date: Date;
  public readonly redeemWindow: CustomRedeemWindow;
  public readonly reference: DocumentReference;
  public readonly timezone: String;
  public readonly data: any;
  public readonly name: string;

  constructor(data: DocumentData) {
    this.date = (data.date as firebase.firestore.Timestamp).toDate();
    this.timezone = data.timezone;
    this.redeemWindow = new CustomRedeemWindow(
      data.redeemWindow.type,
      data.redeemWindow.dayOfEventBeginTime,
      data.redeemWindow.dayOfEventEndTime,
      data.redeemWindow.daysAfterEvent
    );
    this.reference = data.reference as DocumentReference;
    this.data = data.data;
    this.name = data.name;
  }
}
